import { LoanApplicationInProgressLayout, GenericErrorLayout, RecentlyDeniedLayout } from '.';
import CantRenewLayout from './cant-renew-layout';
import { CnpjErrorReason } from 'generated/graphql';
import useNavigation from 'hooks/navigation';
import { setStep, Step } from 'actions/step.action';
import { registerPageView } from 'configs/trackers';

export type CnpjValidationErrorMessageProps = {
    cnpjErrorReason: CnpjErrorReason;
    daysLeft?: number;
};

const CnpjValidationErrorMessage: React.FC<CnpjValidationErrorMessageProps> = ({ cnpjErrorReason, daysLeft }) => {
    setStep(Step.FLOW_FINISHED);

    const { goToBizcapitalSite } = useNavigation();

    if (cnpjErrorReason === 'CANT_RENEW') {
        registerPageView('pedido/analise/negado-empréstimo-concedido-recente');
        return (
            <CantRenewLayout onOk={goToBizcapitalSite} />
        )
    }

    if (cnpjErrorReason === 'OFFER_IN_PROGRESS') {
        registerPageView('pedido/analise/negado-cnpj-com-pedido');
        return (
            <LoanApplicationInProgressLayout onOk={goToBizcapitalSite} />
        )
    }

    if (cnpjErrorReason === 'REQUEST_DENIED') {
        registerPageView('pedido/analise/negado-pedido-recente');
        return (
            <RecentlyDeniedLayout onOk={goToBizcapitalSite} daysLeft={daysLeft} />
        )
    }

    return (
        <GenericErrorLayout onOk={goToBizcapitalSite} />
    )
};

export default CnpjValidationErrorMessage;
